import './CubeLogo.css';

const LOGO_URL = "https://res.cloudinary.com/dwoegbacd/image/upload/q_auto/f_auto/v1775742666/LEO_transparant_B_unylmw.png";

export default function CubeLogo() {
  return (
    <div className="cube-container" role="img" aria-label="LEO">
      <div className="cube" aria-hidden="true">
        {[...Array(6)].map((_, i) => (
          <div key={i} className={`face face-${i + 1}`}>
            <img src={LOGO_URL} alt="" width={60} height={60} className="w-full h-full object-contain p-2" referrerPolicy="no-referrer" />
          </div>
        ))}
      </div>
    </div>
  );
}
